export interface Prize {
  rank: string;
  badge: string;
  image: string;
  label: string;
  /** Raised above the others — the podium winner */
  featured?: boolean;
}

// Podium order: runner-up left, winner raised in the centre, third right.
// Shared by Spin Intro and How It Works so the two can't drift apart.
export const PRIZES: Prize[] = [
  {
    rank:  '2nd',
    badge: '/images/prize-2nd.png',
    image: '/images/winner-2nd.png',
    label: '2 CTTW\nDIAMOND STUDS',
  },
  {
    rank:     '1st',
    badge:    '/images/prize-1st.png',
    image:    '/images/winner-1st.png',
    label:    '4 CTTW\nDIAMOND STUDS',
    featured: true,
  },
  {
    rank:  '3rd',
    badge: '/images/prize-3rd.png',
    image: '/images/winner-3rd.png',
    label: '1 CTTW\nDIAMOND STUDS',
  },
];
